<mat-card>
  <mat-card-title>{{ 'users_roles/roles' | translate }}</mat-card-title>
  <mat-card-subtitle>{{ 'users_roles/section/company_roles/roles_limited' | translate }}</mat-card-subtitle>
  <mat-card-content>
    <h2 *ngIf="!companyRoles.length; else checkboxesTemplate" translate="users_roles/no_roles_defined"></h2>
    <ng-template #checkboxesTemplate>
      <div class="company-roles">
        <mat-checkbox
          *ngFor="let role of companyRoles"
          [checked]="companySet.has(role.id)"
          [disabled]="!companySet.has(role.id) && cannotAddRoles"
          (change)="roleSelectionChanged($event, role.id)">
          {{ role.name }}
        </mat-checkbox>
      </div>
    </ng-template>
    <div class="alcmeon-roles">
      <mat-checkbox *ngFor="let role of alcmeonRoles" [checked]="alcmeonSet.has(role.id)" disabled>
        {{ role.name }}
      </mat-checkbox>
    </div>
  </mat-card-content>
</mat-card>
